import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./realestate.css";
import HeroFooter from "../../components/footer";
import ScrollToTop from "./scrolltop";
import newimg from "../../assets/images/offeringback.webp"

const categories = [
  "Contract Management",
  "Foreign Collaborations",
  "Joint Ventures",
  "Corporate Law",
  "Information Technology",
  "Business Ventures",
  "MSME",
  "Start-up India Initiatives",
  "Property and Real Estate"
];

// Map each category to a custom slug
const categoryMapping = {
  "Contract Management": "contract",
  "Foreign Collaborations": "foreign",
  "Joint Ventures": "joint",
  "Corporate Law": "corporate",
  "Information Technology": "information",
  "Business Ventures": "buisness",
  "MSME": "msme",
  "Start-up India Initiatives": "startup",
  "Property and Real Estate": "realestate"
};

const JointVentures = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const toggleSidebar = () => setSidebarOpen(prev => !prev);
  
  return (
    <div className="practice-page">
         <ScrollToTop/>
      <div className="mobile-menu-button" onClick={toggleSidebar}>
        <i className="fa fa-bars" aria-hidden="true"></i>
      </div>
      
      <aside className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <h2 className="sidebar-title">Our Offerings</h2>
        <ul className="category-list">
          {categories.map((category, index) => (
            <li key={index} className={category === "Joint Ventures" ? "active" : ""}>
              <Link
                onClick={() => setSidebarOpen(false)}
                to={`/${categoryMapping[category]}`}
              >
                {category}
              </Link>
            </li>
          ))}
        </ul>
      </aside>
      
      <main className="conten">
      {/* <img className="offerimg" src={newimg}  /> */}
        <h2>Joint Ventures</h2>
        <p className="intro">
          InduratnaLaw’s Joint Ventures service is designed to align strategic interests across businesses. We ensure that all parties achieve a mutual understanding, legal compliance, and effective risk management.
        </p>
        <section className="details">
          <h3>Our Expertise</h3>
          <p>
            We guide our clients through the intricate process of forming joint ventures—from negotiations to drafting robust contractual agreements that protect each partner's interests.
          </p>
          <h3>Key Services</h3>
          <ul>
            <li>Strategic Partnership Advisory</li>
            <li>Joint Venture Agreement Drafting</li>
            <li>Due Diligence and Risk Assessment</li>
            <li>Regulatory and Compliance Support</li>
            <li>Dispute Resolution Mechanisms</li>
          </ul>
          <h3>Why Choose InduratnaLaw?</h3>
          <p>
            Our dedicated team ensures that every joint venture is strategically sound and built on a foundation of trust, compliance, and mutual benefit.
          </p>
        </section>
      </main>
      <HeroFooter />
    </div>
  );
};

export default JointVentures;
